import {
  IUserGaDataLayerResponseSchema,
} from '@cian/api-models/monolith-python/cian-api/site/v1/get-user-ga-data-layer-data';

export interface IAnalyticsState {
  abGroup?: number;
  userGaData?: IUserGaDataLayerResponseSchema;
}

export function analytics(state: IAnalyticsState = {}) {
  return state;
}
